import { ShopifyProductVariant } from '@aether/models'
import { mapImage } from '../helpers/mapImage'

export const mapProduct = (input: any): ShopifyProductVariant => {
  return {
    ...input,
    image: input.image ? mapImage(input.image) : null,
  }
}
